import React from 'react'
import { observer } from 'mobx-react-lite'

import IconButton from '@mui/material/IconButton'

import { Settings as SettingsIcon } from '@mxenabled/mx-icons'

import { Drawer, Loader, useAppConfig, useGlobalCopyStore, useGlobalUiStore } from '../../common'
import { type Notification, NotificationTypes } from '../../core'

import { NotificationSettings } from '../../settings'

import NotificationList from './NotificationList'

interface NotificationDrawerProps {
  notificationTypes?: NotificationTypes[]
  isOpen: boolean
  onClose: () => void
  onNotificationClick?: (notification: Notification) => void
}

export const NotificationDrawer = observer(
  ({ notificationTypes, isOpen, onClose, onNotificationClick }: NotificationDrawerProps) => {
    const { config } = useAppConfig()
    const { notifications: copy, settings: settingsCopy } = useGlobalCopyStore()
    const { isCopyLoaded } = useGlobalUiStore()

    const [shouldShowSettings, setShouldShowSettings] = React.useState(false)

    if (!isCopyLoaded) return <Loader />

    return (
      <>
        <Drawer
          ariaLabelClose={copy.close_notifications}
          isOpen={isOpen}
          onClose={onClose}
          title={copy.notifications_title}
        >
          <IconButton
            aria-label={settingsCopy.open_notification_settings_btn_aria}
            onClick={() => setShouldShowSettings(true)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <SettingsIcon size={24} />
          </IconButton>

          <NotificationList
            notificationTypes={notificationTypes}
            onClick={onNotificationClick}
            onManageNotifications={() => setShouldShowSettings(true)}
          />
        </Drawer>
        <Drawer
          ariaLabelClose={copy.close_notification_settings}
          isOpen={shouldShowSettings}
          onClose={() => setShouldShowSettings(false)}
          title={settingsCopy.notification_settings_title}
        >
          <NotificationSettings
            notificationTypes={notificationTypes}
            showPersonalDetails={!config.display_user_profile_in_settings}
          />
        </Drawer>
      </>
    )
  },
)
